<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
              id="collapseOne"
              aria-labelledby="headingOne"
              class="collapse show"
              data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form>
                <em-filter
                    ref="emListFilter"
                    $_em-custom-vuex-mixin_filter="receive103Filter"
                    $_em-custom-vuex-mixin_vo="receive103Vo"
                    :entity="modelName"
                    query-api="receive103Query"
                    @showEntityModalSelect="
                    $_emCommonModalMixin_showModalSelectorByFilter
                  "
                ></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryItemResultTable" class="content">
        <div class="card my-1">
          <div
              id="collapseTwo"
              aria-labelledby="headingTwo"
              class="collapse show"
              data-parent="#accordionResult"
          >
            <div class="card-body">
              <em-table
                  ref="emTable"
                  $_em-custom-vuex-mixin_filter="receive103Filter"
                  $_em-custom-vuex-mixin_vo="receive103Vo"
                  :entity="modelName"
                  :inlineActionsDisabled="prop_inline !== '1'"
                  query-api="receive103Query"
                  withCustomRowActionsFirstColumn
                  @showModalSelectorByEditRow="
                  $_emCommonModalMixin_showModalSelectorByEditRow
                "
                  @showModalSelectorByNewRow="
                  $_emCommonModalMixin_showModalSelectorByNewRow
                "
              >
                <template #left-header>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="receiveItem()"
                  >
                    扫码103
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="returnItem()"
                  >
                    扫码104
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('select')"
                      @click="openBatchReceive()"
                  >
                    手动103
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('selectOne')"
                      @click="openBatchReturn()"
                  >
                    手动104
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('selectOne')"
                      @click="createAbnormalArrivalProcess()"
                  >
                    发起异常到货
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('select')"
                      @click="openUpdateArea()"
                  >
                    批量设置存放区域
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateInventoryStatus()"
                  >
                    批量更改物流状态
                  </b-button>
                  <!-- <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('selectOne')"
                      @click="openBatchReceive105()"
                    >
                      手动105
                  </b-button>
                  <em-button
                      type= 'search' custom-icon="fa fa-fw fa-sm fa-undo-alt"
                      custom-label="手动106"
                      :showName="true"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      :disabled="actionDisabled('selectOne')"
                      @click="openBatchReturn106()"
                      :busy="processing106"
                    >
                  </em-button> -->
                </template>
                  <template #customRowActionsFirstColumn="{ row }">

                      <b-button-group>
                          <em-button type="edit"  custom-icon="fa fa-fw fa-lg fa-search"
                                     custom-label="分批入厂，收货，退货信息"
                                     v-bind:class="'btn btn-outline-primary btn-sm'"
                                     @click="showEdit(row)">
                          </em-button>
                          <em-button
                                  type="gotoChild"
                                  customLabel="查看打包物料"
                                  v-bind:class="'btn btn-outline-primary btn-sm'"
                                  @click="gotoChild(row)"
                          ></em-button>
                          <em-button
                                  type="gotoChild"
                                  customLabel="查看104记录"
                                  v-bind:class="'btn btn-outline-primary btn-sm'"
                                  @click="goto104(row)"
                          ></em-button>
                      </b-button-group>
                  </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector
        ref="emModalEntitySelector"
    ></em-modal-entity-selector>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="receiveDialogVisible" title="扫码103" width="70%"
               @close='clearItemList'>
      <el-table border :data="itemList" style="width:100%" max-height="285px" empty-text="请点击打开扫码框扫码">
        <el-table-column label="PO" width="120" fixed prop="purchaseNumber"></el-table-column>
        <el-table-column label="ITEM" width="100" prop="itemCode"></el-table-column>
        <el-table-column label="类别" width="50" prop="category"></el-table-column>
        <el-table-column label="名称" width="150" prop="materielName"></el-table-column>
        <el-table-column label="单位" width="50" prop="materielUnit"></el-table-column>
        <el-table-column prop="urgency" label="紧急程度">
          <template slot-scope="scope">
            {{ getUrgencyName(scope.row.urgency) }}
          </template>
        </el-table-column>
        <el-table-column prop="taxFlag" label="免税标记">
          <template slot-scope="scope">
            {{ getTaxFlagName(scope.row.taxFlag) }}
          </template>
        </el-table-column>
        <el-table-column label="到货数量" width="100" prop="arrivedQuantity"></el-table-column>
        <el-table-column label="累计103" prop="receiptQuantity"></el-table-column>
        <el-table-column label="本次103数量" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.currentQuantity" clearable size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="存放区域" width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.locId" placeholder="请选择">
              <el-option
                  v-for="area in areas"
                  :key="area.id"
                  :label="area.name"
                  :value="area.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="生产日期" width="220">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.productionDate" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="保质期" width="80">
          <template slot-scope="scope">
            <el-input v-model="scope.row.shelfLife"></el-input>
          </template>
        </el-table-column>
      </el-table>

        <el-dialog :center="true" :close-on-click-modal='false' append-to-body :visible.sync="openScanner"
                   title="扫一扫"
                 @close="closeScannerDialog">
        <qr-code-scanner ref="scanner" @getCodeData='getCodeData'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="receiveDialogVisible = false">取 消</el-button>
        <el-button @click="openScannerDialog()">打开扫码框</el-button>
        <!-- <el-button @click="createAbnormalArrivalProcess()" :disabled="itemList.length == 0">发起异常</el-button> -->
        <el-button type="primary" @click="batchReceive103()" :disabled="itemList.length == 0">确认103</el-button>
      </div>
    </el-dialog>

    <el-dialog title="扫码104" :visible.sync="returnDialogVisible" :close-on-click-modal='false' append-to-body @close='clearItemList'>
      <el-table ref="recordTable" :data="receiveRecords" max-height="285px" style="width:100%"
                @selection-change="handleSelect">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="PO" fixed prop="poNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="收货数量" prop="receiptQuantity"></el-table-column>
        <el-table-column label="已退数量" prop="returnQuantity"></el-table-column>
        <el-table-column label="已过105数量" prop="childReceiptQuantity"></el-table-column>
        <el-table-column label="凭据号" prop="credential"></el-table-column>
        <el-table-column label="收货时间" prop="operateTime"></el-table-column>
        <el-table-column label="本次104数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.currentReturn" clearable size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>
        <el-dialog :center="true" :close-on-click-modal='false' append-to-body :visible.sync="openReturnScanner"
                 title="扫一扫" @close="closeReturnScannerDialog">
        <qr-code-scanner ref="returnScanner" @getCodeData='getRecord103Data'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="returnDialogVisible = false">取 消</el-button>
        <el-button @click="openReturnScannerDialog()">打开扫码框</el-button>
        <el-button type="primary" @click="batchReturn104New()" :disabled="itemList.length == 0">确认退货</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchReceiveDialogVisible" title="手动103"
               @close='clearItemList'>
      <el-table border :data="itemList" style="width:100%" max-height="285px" empty-text="请点击打开扫码框扫码">
        <el-table-column label="PO" width="120" fixed prop="purchaseNumber"></el-table-column>
        <el-table-column label="ITEM" width="100" prop="itemCode"></el-table-column>
        <el-table-column label="类别" width="50" prop="category"></el-table-column>
        <el-table-column label="名称" width="150" prop="materielName"></el-table-column>
        <el-table-column label="单位" width="50" prop="materielUnit"></el-table-column>
        <el-table-column label="到货数量" width="100" prop="arrivedQuantity"></el-table-column>
        <el-table-column label="累计103" prop="receiptQuantity"></el-table-column>
        <el-table-column label="本次103数量" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.currentQuantity" clearable size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="存放区域" width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.locId" placeholder="请选择">
              <el-option
                  v-for="area in areas"
                  :key="area.id"
                  :label="area.name"
                  :value="area.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="生产日期" width="220">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.productionDate" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="保质期" width="80">
          <template slot-scope="scope">
            <el-input v-model="scope.row.shelfLife"></el-input>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchReceiveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchReceive103()">确认103</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchReturnDialogVisible" title="手动104"
               @close='clearQuantity'>
      <el-table ref="recordTable" :data="receiveRecords" max-height="285px" style="width:100%"
                @selection-change="handleSelect">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="PO" fixed prop="poNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="收货数量" prop="receiptQuantity"></el-table-column>
        <el-table-column label="已退数量" prop="returnQuantity"></el-table-column>
        <el-table-column label="已过105数量" prop="childReceiptQuantity"></el-table-column>
        <el-table-column label="凭据号" prop="credential"></el-table-column>
        <el-table-column label="收货时间" prop="operateTime"></el-table-column>
        <el-table-column label="本次104数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.currentReturn" clearable size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchReturn104New()">确认104</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchReceive105DialogVisible" title="手动105"
               @close='clearQuantity'>
      <el-table ref="recordTable" :data="receiveRecords" max-height="285px" style="width:100%"
                @selection-change="handleSelect">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="PO" fixed prop="poNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="收货数量" prop="receiptQuantity"></el-table-column>
        <el-table-column label="已退数量" prop="returnQuantity"></el-table-column>
        <el-table-column label="已过105数量" prop="childReceiptQuantity"></el-table-column>
        <el-table-column label="凭据号" prop="credential"></el-table-column>
        <el-table-column label="收货时间" prop="operateTime"></el-table-column>
        <el-table-column label="质检结果" prop="inspectStatus">
          <template slot-scope="scope">
            {{ inspectStatusName(scope.row.inspectStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="本次105数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.currentReceive" clearable size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchReceive105()">确认105</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchReturn106DialogVisible" title="手动106"
               @close='clearQuantity'>
      <el-table ref="recordTable" :data="receiveRecords" max-height="285px" style="width:100%"
                @selection-change="handleSelect">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="PO" fixed prop="poNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="105数量" prop="receiptQuantity"></el-table-column>
        <el-table-column label="已退数量" prop="returnQuantity"></el-table-column>
        <el-table-column label="凭据号" prop="credential"></el-table-column>
        <el-table-column label="105时间" prop="operateTime"></el-table-column>
        <el-table-column label="批次号" prop="batchNumber"></el-table-column>
        <el-table-column label="本次106数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.currentReturn" clearable size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchReturn106()">确认106</el-button>
      </div>
    </el-dialog>
    <!-- 批量设置存放区域 -->
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateAreaVisible" title="批量设置存放区域" width="30%"
               @close='clearUpdateArea'>
      <el-form ref="updateAreaForm" :model="updateAreaForm" :rules="updateAreaRule" label-width="auto">
        <el-form-item label="存放区域" prop="locId">
          <el-select v-model="updateAreaForm.locId" placeholder="请选择">
            <el-option
                v-for="area in areas"
                :key="area.id"
                :label="area.name"
                :value="area.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateAreaVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateArea()">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateInventoryStatusVisible" title="批量更改物流状态"
               width="30%" z-index="1000" @close='clearUpdateInventoryStatus'>
      <el-form ref="updateInventoryStatusForm" :model="updateInventoryStatusForm" :rules="updateInventoryStatusRules"
               label-width="auto">
        <b-form-input
            id="inventoryStatusSelector"
            v-model="updateInventoryStatusForm.inventoryStatusCode"
            class="form-control col-2 inventory-status"
            placeholder="请选择物流状态"
            plaintext
            type="text"
            @click="$refs.inventoryStatusSelector.showModal()"
        ></b-form-input>
        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.inventoryStatusList"
                 :select-mode='selectMode'
                 max-height="285px"
                 selectable
                 style="width:100%"
                 @row-selected="onRowSelected">
        </b-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateInventoryStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateInventoryStatus()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="inventoryStatusSelector" entity="sithMesInventoryStatus"
                                             @entityModalSelectSelected="updateInventoryStatus">
      </em-modal-normal-input-entity-selector>
    </el-dialog>
      <re-b-modal ref="batchRecordData" header= '分批到货信息'
                  fit-content
                  large>
          <div class="d-flex flex-column h-100 position-relative">
              <mini-table ref="batchRecordTable"
                          class="flex-grow-1 overflow-auto"
                          entity-name="sithMesInventoryReceiptReturnRecord"
                          :items="batchRecord"
                          :total-count="totalCount"
                          read-only sortable
                          enable-pagination
                          disable-first-index-column
                          need-model-fields>
              </mini-table>
          </div>
      </re-b-modal>
  </div>
</template>
<script>
// Author Lin
// Date 2021-04-21 11:22:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
  name: "sithMesInventoryItemListView",
  components: {ReBModal, MiniTable, qrCodeScanner, EmModalNormalInputEntitySelector},
  mixins: [emCommonListMixin, emCommonApiMixin, qrCodeScanner, emCommonGotoMixin,emCommonUtilMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      receiveDialogVisible: false,
      returnDialogVisible: false,
      openScanner: false,
      itemList: [],
      quantityForm: {
        receivedQuantity: "",
        productionDate: "",
        shelfLife: "",
        locId: ""
      },
      returnQuantityForm: {
        returnQuantity: "",
      },
      // 存放区域
      areas: [],
      // 批量收103的对话框
      batchReceiveDialogVisible: false,
      // 批量104的对话框
      batchReturnDialogVisible: false,
      // 收货记录数组
      receiveRecords: [],
      // 选中的将收货或退货的数组
      recordsToReturn: [],
      // 批量106退货的对话框
      batchReturn106DialogVisible: false,
      // 批量收105的对话框
      batchReceive105DialogVisible: false,
      // 控制批量106按钮是否显示小圆圈不可点
      processing106: false,
      openReturnScanner: false,
      updateAreaVisible: false,
      updateAreaForm: {
        locId: ''
      },
      updateAreaRule: {locId: [{required: true, message: '请选择存放区域'}]},

      updateInventoryStatusVisible: false,
      updateInventoryStatusForm: {
        inventoryStatusCode: ''
      },
      updateInventoryStatusRules: {inventoryStatusCode: [{required: true, message: '请选择物流状态！'}]},
        batchRecord:[],
        page: {
            pageNumber: 1,
            pageSize: 10,
        },
        totalCount: 100,
    }
  },
  computed: {
    modelName() {
      return "sithMesInventoryItem"
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItemsReceive103Vo"];
      // return this.$refs.emTable.checkedItems
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItemsReceive103Vo"].join(",");
    },
  },
  methods: {
    //根据按钮上设置的选中类型和实际列表中选中的项目，判断按钮是否可点
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    receiveItem() {
      this.receiveDialogVisible = true;
    },
    returnItem() {
      this.returnDialogVisible = true;
    },
    clearItemList() {
      this.itemList = [];
      this.quantityForm.receivedQuantity = '';
      this.returnQuantityForm.returnQuantity = '';
      this.quantityForm.productionDate = '';
      this.quantityForm.shelfLife = '';
      this.quantityForm.locId = '';
    },
    closeScannerDialog() {
      this.$refs.scanner.closeCamera();
      this.$refs.scanner.resetOutputData();
      this.openScanner = false;
    },
    closeReturnScannerDialog() {
      this.$refs.returnScanner.closeCamera();
      this.$refs.returnScanner.resetOutputData();
      this.openReturnScanner = false;
    },
    getCodeData(data) {
      console.log("get qr code data:" + data);
      this.openScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }

      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/`;
      _url += `checkIf103Received?poNumber=${poNumber}&item=${item}&type=103`;
      this.$_emApiMixin_get(_url, {})
          .then((value) => {
            var arr = Object.keys(value);
            if (arr.length != 0) {
              console.log("value======" + JSON.stringify(value));
              self.itemList = [];
              self.itemList.push(value);
              self.$message({
                message: "扫码成功",
                type: "success",
              });
            } else {
              self.$message({
                message: "无对应物料或物料已收货",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.openScanner = false;
          });
    },
    confirmReceive(type) {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/confirmReceive103`;
      let requestBody = {};
      let ids = '';
      if (type === 'scan') {
        ids = self.itemList.map(obj => {
          return obj.id
        }).join(",");
      }
      if (type === 'manual') {
        ids = this.selectIds;
      }
      requestBody.idStr = ids;
      requestBody.receiveQuantity = self.quantityForm.receivedQuantity;
      requestBody.productionDate = self.quantityForm.productionDate;
      requestBody.shelfLife = self.quantityForm.shelfLife;
      self.$_emApiMixin_post(_url, requestBody)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "确认收货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "确认收货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.receiveDialogVisible = false;
            this.batchReceiveDialogVisible = false;
          });
    },
    confirmReturn() {
      let self = this;
      let itemId = self.itemList[0].id;
      let returnQuantity = self.returnQuantityForm.returnQuantity;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/confirmReturn104?poItemId=${itemId}&returnQuantityStr=${returnQuantity}`;
      self.$_emApiMixin_post(_url, {})
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "104退货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "104退货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.returnDialogVisible = false;
          });
    },
    getAreas() {
      this.$_emApiMixin_findByFilter("sithMesInventoryAreaLoc", {}).then(
          (data) => {
            this.areas = data.map((m) => {
              return {id: m.id, name: m.areaName};
            });
          }
      );
    },
    openBatchReceive() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/obtainItemsWithReceiptQuantity?ids=${self.selectIds}&type=103`;
      self.$_emApiMixin_post(_url, {})
          .then((response) => {
            if (response.status === 200) {
              self.itemList = response.data;
              self.batchReceiveDialogVisible = true;
            } else {
              self.$message({
                message: "查询失败",
                type: "error",
              });
            }
          })
    },
    openBatchReturn() {
      let self = this;
      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findAllByPoitemId?ids=${self.selectIds}&type=103`;
      self.$_emApiMixin_get(url, {})
          .then(response => {
            if (response instanceof Array) {
              if (response.length === 0) {
                self.$message({
                  message: "无收货记录！",
                  type: "error",
                });
              } else {
                self.receiveRecords = response.map(record => {
                  if (typeof (record.returnQuantity) == "undefined") {
                    record.returnQuantity = 0;
                  }
                  if (typeof (record.childReceiptQuantity) == "undefined") {
                    record.childReceiptQuantity = 0;
                  }
                  let leftQuantity = record.receiptQuantity - record.returnQuantity - record.childReceiptQuantity;
                  return Object.assign(record, {currentReceive: leftQuantity, currentReturn: leftQuantity});
                })
                self.batchReturnDialogVisible = true;
              }
            }
          })
    },
    openBatchReceive105() {
      let self = this;
      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findAllByPoitemId?ids=${self.selectIds}&type=103`;
      self.$_emApiMixin_get(url, {})
          .then(response => {
            if (response instanceof Array) {
              if (response.length === 0) {
                self.$message({
                  message: "无收货记录！",
                  type: "error",
                });
              } else {
                self.receiveRecords = response.map(record => {
                  if (typeof (record.returnQuantity) == "undefined") {
                    record.returnQuantity = 0;
                  }
                  if (typeof (record.childReceiptQuantity) == "undefined") {
                    record.childReceiptQuantity = 0;
                  }
                  let leftQuantity = record.receiptQuantity - record.returnQuantity - record.childReceiptQuantity;
                  return Object.assign(record, {currentReceive: leftQuantity, currentReturn: leftQuantity});
                })
                self.batchReceive105DialogVisible = true;
              }
            }
          })
    },
    batchReceive103() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReceive103`;
      self.$_emApiMixin_post(_url, self.itemList)
          .then((response) => {
            if (response.status === 200) {
              self.$message({
                message: "103收货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "103收货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.receiveDialogVisible = false;
            this.batchReceiveDialogVisible = false;
          });
    },
    batchReturn104() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReturn104`;
      let requestBody = {};
      requestBody.idStr = self.selectIds;
      requestBody.receiveQuantity = self.quantityForm.receivedQuantity;
      self.$_emApiMixin_post(_url, requestBody)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "104退货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "104退货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.batchReturnDialogVisible = false;
          });
    },
    batchReturn104New() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReturn104New`;
      self.$_emApiMixin_post(_url, self.recordsToReturn)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "104退货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "104退货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.batchReturnDialogVisible = false;
          });
    },
    batchReceive105() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReceive105`;
      self.$_emApiMixin_post(_url, self.recordsToReturn)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "105收货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "105收货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.batchReceive105DialogVisible = false;
          });
    },
    clearQuantity() {
      this.quantityForm.receivedQuantity = '';
      this.receiveRecords = [];
    },
    handleSelect(selection) {
      this.recordsToReturn = selection;
    },
    openBatchReturn106() {
      let self = this;
      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findAllByPoitemId?ids=${self.selectIds}&type=105`;
      self.$_emApiMixin_get(url, {})
          .then(response => {
            if (response instanceof Array) {
              if (response.length === 0) {
                self.$message({
                  message: "无收货记录！",
                  type: "error",
                });
              } else {
                self.receiveRecords = response.map(record => {
                  if (typeof (record.returnQuantity) == "undefined") {
                    record.returnQuantity = 0;
                    return Object.assign(record, {currentReturn: record.receiptQuantity})
                  } else {
                    return Object.assign(record, {currentReturn: record.receiptQuantity - record.returnQuantity});
                  }
                })
                self.batchReturn106DialogVisible = true;
              }

            }
          })
    },
    batchReturn106() {
      let self = this;
      self.processing106 = true;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReturn106`;
      self.$_emApiMixin_post(_url, self.recordsToReturn)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "106退货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "106退货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            self.batchReturn106DialogVisible = false;
            self.processing106 = false;
          });
    },
    inspectStatusName(status) {
      if (status) {
        switch (status) {
          case 1:
            return '合格'
          case 2:
            return '已提交'
          case 3:
            return '未提交'
          case 4:
            return '不合格'
        }
      }
    },
    // 用于104退货，根据扫码信息查询对应POITEM的所有103收货记录
    getRecord103Data(data) {
      console.log("get qr code data:" + data);
      this.openReturnScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }

      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findAllByPoItemNumber?poNumber=${poNumber}&itemCode=${item}&type=103`;
      self.$_emApiMixin_get(url, {})
          .then(response => {
            if (response instanceof Array) {
              if (response.length === 0) {
                self.$message({
                  message: "无103收货记录！",
                  type: "error",
                });
              } else {
                self.receiveRecords = response.map(record => {
                  if (typeof (record.returnQuantity) == "undefined") {
                    record.returnQuantity = 0;
                  }
                  if (typeof (record.childReceiptQuantity) == "undefined") {
                    record.childReceiptQuantity = 0;
                  }
                  let leftQuantity = record.receiptQuantity - record.returnQuantity - record.childReceiptQuantity;
                  return Object.assign(record, {currentReceive: leftQuantity, currentReturn: leftQuantity});
                })
              }

            } else {
              self.$message({
                message: "无103收货记录！",
                type: "error",
              });
            }
          }).finally(() => {
        this.openReturnScanner = false;
      });
    },
    // 获取紧急程度整数标识对应的描述
    getUrgencyName(type) {
      if (type) {
        switch (type) {
          case 0:
            return '紧急'
          case 1:
            return '一般'
        }
      }
    },
    // 获取免税标记整数标识对应的描述
    getTaxFlagName(type) {
      if (type) {
        switch (type) {
          case 0:
            return '免税'
          case 1:
            return '不免税'
        }
      }
    },
    createAbnormalArrivalProcess() {
      // let poItemId = this.itemList[0].id;
      let poItemId = this.selectIds;
      console.log("异常的物料：" + poItemId);
      this.$router.push(
          "/sithMes/inventory/sithMesInventoryAbnormalArrivalProcessEdit"
      );
      this.$store.commit(
          "sithMesInventoryAbnormalArrivalProcess/setNewEntity",
          {}
      );
      this.$store.commit(
          "sithMesInventoryAbnormalArrivalProcess/setCrudState",
          "edit"
      );
      this.$store.commit(
          "sithMesInventoryAbnormalArrivalProcess/setEntityAttribute",
          {key: "poItemId", newValue: poItemId}
      );
    },
    openScannerDialog() {
      this.openScanner = true;
      setTimeout(() => {
        this.$refs.scanner.openCamera('');
      }, 500);
    },
    openReturnScannerDialog() {
      this.openReturnScanner = true;
      setTimeout(() => {
        this.$refs.returnScanner.openCamera('');
      }, 500);
    },
    gotoChild(row) {
      this.$_emGotoMixin_gotoHolderList(
          "sithMesInventoryPackingBom",
          {itemIdFilter: row.id},
          {itemId: row.id},
          false,
          {}
      );
    },
    goto104(row) {
      this.$router.push(
          {
            name: 'sithMesInventorySapRecord104List',
            query: {poItemId: row.id}
          }
      );
    },
    openUpdateArea() {
      this.updateAreaVisible = true;
    },
    clearUpdateArea() {
      this.updateAreaForm.locId = ''
    },
      whenPageChange(page,row) {
          this.page = page;
          this.doQuery(row);
      },
      showEdit(row) {
          this.row = row;
          this.doQuery();
          this.$refs.batchRecordData.showModal();
      },
      doQuery() {
          let form = {
              poitemIdFilter: this.row.id,
              sortingBy : [{column: "operateType", order: "asc"},{column: "operateTime", order: "asc"}]
          }
          let nPage = {
              currentPage: this.page.pageNumber,
              numRegPag: this.page.pageSize,
          }
          this.copyObj2Obj(nPage, form);
          let uri  = `${this.$_emApiMixin_entityBaseApi('sithMesInventoryReceiptReturnRecord')}/findByFilter`;
          this.$_emApiMixin_post(uri,form)
                  .then((response)=> {
                      this.batchRecord = response.data.list
                      this.totalCount = response.data.pagination.totalReg
                  });
      },
    batchUpdateArea() {
      let self = this;
      self.$refs["updateAreaForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateArea?ids=${this.selectIds}&locId=${self.updateAreaForm.locId}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateAreaVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },

    updateInventoryStatus(selectRow) {
      console.log(selectRow)
      this.updateInventoryStatusForm.inventoryStatusCode = selectRow.code;
    },

    openUpdateInventoryStatus() {
      this.updateInventoryStatusVisible = true;
    },
    clearUpdateInventoryStatus() {
      this.updateInventoryStatusForm.inventoryStatusCode = ''
    },
    batchUpdateInventoryStatus() {
      let self = this;
      this.$refs["updateInventoryStatusForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateInventoryStatus?ids=${this.selectIds}&inventoryStatusCode=${self.updateInventoryStatusForm.inventoryStatusCode}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量更改物流状态成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量更改物流状态失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateInventoryStatusVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
  },
  mounted() {
    if (this.$route.query.hasOwnProperty("id")) {
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
      this.$refs.emListFilter.doQuery();
    } else if (this.$route.query.hasOwnProperty("ids")) {
        this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idListFilter', this.$route.query.ids.split(","));
        this.$refs.emListFilter.doQuery();
    }
    this.getAreas();
  },
};
</script>
